export class DateUtils {
    static diasDiff(date) {
        if (!date)
            return 0;

        const agora = new Date();
        const ultimoAcesso = new Date(date);

        const diferencaMs = agora - ultimoAcesso;

        return Math.abs(
            Math.floor(diferencaMs / 1000 / 60 / 60 / 24)
        );
    }

    static calcularDiferenca(ultimoAcesso) {
        if (!ultimoAcesso)
            return '';

        const dias = this.diasDiff(ultimoAcesso);

        if (dias > 0)
            return `(${dias} dias)`;

        const agora = new Date();
        const data = new Date(ultimoAcesso);

        const diferencaMs = agora - data;
        const diferencaMinutos = Math.abs(
            Math.floor(diferencaMs / 1000 / 60)
        );

        if (diferencaMinutos >= 60) {
            return `(${Math.floor(diferencaMinutos / 60)} horas)`;
        }

        return `(${diferencaMinutos} minutos)`;
    }

    static convertDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day.substring(0, 2)}-${month}-${year}`
    }

    static convertTime(date) {
        if (!date) return null

        const dateTime = new Date(date)

        // const [, , dayTime] = dateTime.split('-')
        return `${dateTime.getHours().toString().padStart(2, '0')}:${dateTime.getMinutes().toString().padStart(2, '0')}:${dateTime.getSeconds().toString().padStart(2, '0')}`
    }
}